import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWip"><Path fillRule="evenodd" clipRule="evenodd" d="M7.5 4V2H6V4H2V14H5.99996V20.5H4.5V22H9V20.5H7.49996V14H16.5V20.5H15V22H19.5V20.5H18V14H22V4H18V2H16.5V4H7.5ZM16.9885 12.5L19.6135 5.5H18.0115L15.3865 12.5H16.9885ZM7.01147 5.5L4.38647 12.5H5.98848L8.61348 5.5H7.01147ZM12.5115 5.5L9.88646 12.5H11.4885L14.1135 5.5H12.5115Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWip;
